// // src/components/BookingDetails.js

// import React from 'react';
// import { useQuery } from 'react-query';
// import axios from 'axios';
// import { useParams } from 'react-router-dom';
// import { Box, Spinner, Text, Alert, AlertIcon } from '@chakra-ui/react';

// const fetchBooking = async (bookingId) => {
//   const { data } = await axios.get(`/payfiles/bookings/${bookingId}`);
//   return data;
// };

// const BookingDetails = () => {
//   const { id } = useParams();
//   const { data, isLoading, isError, error } = useQuery(['booking', id], () => fetchBooking(id));

//   if (isLoading) {
//     return <Spinner />;
//   }

//   if (isError) {
//     return (
//       <Alert status="error">
//         <AlertIcon />
//         {error.message}
//       </Alert>
//     );
//   }

//   return (
//     <Box>
//       <Text>User: {data.userId.name}</Text>
//       <Text>Item: {data.item.name}</Text>
//       <Text>Amount: {data.amount}</Text>
//       <Text>Status: {data.status}</Text>
//       <Text>Billing Method: {data.billingmethod}</Text>
//       <Text>Date: {new Date(data.createdAt).toLocaleDateString()}</Text>
//     </Box>
//   );
// };

// export default BookingDetails;
// src/components/BookingDetails.js

import React from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';

const BookingDetails = () => {
  const  state  = useLocation();
  const { booking } = state || {};

  console.log(state)
  if (!booking) {
    return <Text>No booking details available.</Text>;
  }

  return (
    <Box p={4}>
      <Heading as="h2" size="lg" mb={4}>Booking Details</Heading>
      <Text><strong>User:</strong> {booking.userId.name}</Text>
      <Text><strong>Email:</strong> {booking.userId.email}</Text>
      <Text><strong>Item:</strong> {booking.item.name}</Text>
      <Text><strong>Amount:</strong> {booking.amount}</Text>
      <Text><strong>Status:</strong> {booking.status}</Text>
      <Text><strong>Billing Method:</strong> {booking.billingmethod}</Text>
      <Text><strong>Created At:</strong> {new Date(booking.createdAt).toLocaleDateString()}</Text>
    </Box>
  );
};

export default BookingDetails;
